import { computed, Signal, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import moment from 'moment';

export interface DateRangeConfig {
  fromMin?: Date | null;
  fromMax?: Date | null;
  toMin?: Date | null;
  toMax?: Date | null;
}

export class DateRangeHelper {
  public readonly fromMin: Signal<Date | null>;
  public readonly fromMax: Signal<Date | null>;
  public readonly toMin: Signal<Date | null>;
  public readonly toMax: Signal<Date | null>;
  public readonly today: Signal<Date>;
  
  private readonly fromValue: Signal<Date | null>;
  private readonly toValue: Signal<Date | null>;

  constructor(
    private readonly fromControl: FormControl<Date>,
    private readonly toControl: FormControl<Date>,
    config: DateRangeConfig = {}
  ) {
    this.today = computed(() => new Date());
    
    const fromValueSignal = signal<Date | null>(this.fromControl.value);
    const toValueSignal = signal<Date | null>(this.toControl.value);
    
    this.fromControl.valueChanges.subscribe(value => fromValueSignal.set(value));
    this.toControl.valueChanges.subscribe(value => toValueSignal.set(value));
    
    this.fromValue = fromValueSignal.asReadonly();
    this.toValue = toValueSignal.asReadonly();

    this.fromMin = computed(() => config.fromMin ?? null);
    this.fromMax = computed(() => {
      if (config.fromMax !== undefined) {
        return config.fromMax;
      }
      const toValue = this.toValue();
      return toValue ? toValue : new Date();
    });

    this.toMin = computed(() => {
      if (config.toMin !== undefined) {
        return config.toMin;
      }
      const fromValue = this.fromValue();
      return fromValue ? fromValue : null;
    });
    this.toMax = computed(() => config.toMax ?? new Date());
  }
}

export function shouldShowClearIcon(control: FormControl): boolean {
  const currentValue = control.value;
  const defaultValue = (control as any).defaultValue;

  if (!currentValue && !defaultValue) return false;
  if (!currentValue || !defaultValue) return true;

  return !moment(currentValue).isSame(defaultValue, 'day');
}
